<template>
  <div id="paper-root">
    <a-spin :spinning="createLoading" size="large">
    <a-layout theme="light">
      <a-layout-header>
        <a-row id="paper-header" type="flex" justify="space-between">
          <a-col :span="8">
            <span @click="paperDescVisible=true"><a-icon v-if="paperInfo.paperDesc" type="question-circle" /> {{(paperDepart&&paperDepart.examName) || paperInfo.paperName}}</span>
          </a-col>
          <a-col :span="16">
            <span>{{$t('exam.student')}}：</span>
            <span class="remain-time">{{userInfo.realname}}</span>
            <a-divider type="vertical"/>
            <span>{{$t('exam.timeLimit')}}：{{paperInfo.timeLimit}}</span>
            <a-divider type="vertical"/>
            <span>{{$t('exam.spendTime')}}<span class="remain-time">{{formatTime(userPaperInfo.duration)}}</span></span>
            <a-divider type="vertical"/>
            <span>{{$t('exam.totalScore')}}:{{paperInfo.totalScore}}</span>
            <a-divider type="vertical"/>
            <span>{{$t('exam.gotScore')}}：<span class="remain-time">{{userPaperInfo.gotScore}}</span></span>
          </a-col>
        </a-row>
      </a-layout-header>
      <a-layout>
        <a-layout-sider :style="{ overflowY: 'auto' }">
          <a-card class="question-index">
            <!-- <div>
              <span>仅看错题：</span>
              <a-switch checkedChildren="是" unCheckedChildren="否"/>
            </div> -->
            <a-row>
              <div v-for="(q, i) in paperQuestion" :key="i">
                <a-col class="question-section" :span="24" v-if="q.questionSection">{{ q.questionSection }}</a-col>
                <a-col :span="6">
                  <a-tag :color="isWriteAnswer(i) ? q.paperQuestionScore==q.gotScore? 'green' : 'red' : ''" @click="jumpQuestion(i)">{{ i + 1 }}</a-tag>
                </a-col>
              </div>
            </a-row>
          </a-card>
          <p>{{$t('exam.tips')}}</p>
          <span>正确&nbsp;</span><a-tag color="green">&nbsp;</a-tag>
          <span>错误&nbsp;</span><a-tag color="red">&nbsp;</a-tag>
          <span>未答&nbsp;</span><a-tag>&nbsp;</a-tag>
        </a-layout-sider>
        <a-layout-content
          :style="{ minHeight: '80vh', height: 'calc(100vh - ' + heightOffset + 'px', overflow: 'auto' }"
        >
          <a-card class="paper-content" :bordered="false">
            <div v-for="(q, qi) in paperQuestion" :key="qi">
              <!-- 题块 -->
              <div class="question-section" v-if="q.questionSection">
                <h2>{{ questionSections[qi].text }}</h2>
                <h3> （共{{questionSections[qi].count}}题，每题{{q.paperQuestionScore}}分，共{{questionSections[qi].score}}分）</h3>
              </div>
              <a-card class="question-card" :id="'q-' + qi">
                <a-row>
                  <!-- 题干 -->
                  <a-col>
                    <div v-if="q.questionType != 4" class="question-stem">
                      <span>{{ qi + 1 }}. （{{ q.paperQuestionScore }}分）</span>
                      <span v-if="!isWriteAnswer(qi)" style="color:red">（未作答）</span>
                      <div v-html-md="q.questionStem"></div>
                    </div>
                    <div v-if="q.questionType == 4" :id="'question-stem-'+q.id" ></div>
                  </a-col>
                  <a-divider />
                  <a-col>
                    <!-- 单选 -->
                    <a-radio-group disabled v-if="q.questionType == 1" v-model="paperAnswer[qi]['myAnswer']">
                      <a-radio v-for="(o, oi) in q.questionOptions" :key="oi" :value="oi">
                        <span class="question-letter">{{ index2letter(oi) }}</span>
                        <div class="question-options-content">
                          <div class="option" v-html-md="o.item"></div>
                        </div>
                      </a-radio>
                    </a-radio-group>
                    <!-- 多选 -->
                    <a-checkbox-group disabled v-if="q.questionType == 2" v-model="paperAnswer[qi]['myAnswer']">
                      <a-checkbox v-for="(o, oi) in q.questionOptions" :key="oi" :value="oi">
                        <span class="question-letter">{{ index2letter(oi) }}</span>
                        <div class="question-options-content">
                          <div class="option" v-html-md="o.item"></div>
                        </div>
                      </a-checkbox>
                    </a-checkbox-group>
                    <!-- 判断题 -->
                    <a-radio-group disabled v-if="q.questionType == 3" v-model="paperAnswer[qi]['myAnswer']">
                      <a-radio value="true"><span class="question-letter">{{ index2letter(0) }}</span>{{$t('exam.right')}}</a-radio>
                      <a-radio value="false"><span class="question-letter">{{ index2letter(1) }}</span>{{$t('exam.wrong')}}</a-radio>
                    </a-radio-group>
                    <!-- 填空题 -->
                    <!-- 已改为虚拟DOM，直接在题干的下划线展示答案 -->
                    <!-- <div v-if="q.questionType == 4">
                      <a-input
                        readOnly
                        v-for="oi in q.questionOptions.fillGapNum"
                        :key="oi"
                        v-model="paperAnswer[qi]['myAnswer'][oi - 1]"
                        :placeholder="'第' + oi + '空回答'"
                      />
                    </div> -->
                    <!-- 主观题 阅读分析-->
                    <div v-if="q.questionType == 5 || q.questionType == 6">
                      <a-textarea
                        readOnly
                        :auto-size="{ minRows: 5, maxRows: 20 }"
                        :placeholder="$t('exam.answerArex')"
                        v-model="paperAnswer[qi]['myAnswer']"
                      ></a-textarea>
                    </div>

                    <!-- 编程题 -->
                    <div v-if="q.questionType == 7">
                      <a-button type="primary" size="large" @click="openEditor(q)" :disabled="!isWriteAnswer(qi)">查看代码</a-button>
                    </div>

                    <!-- OJ编程题 -->
                    <div v-if="q.questionType == 8">
                      <a-button type="primary" size="large" @click="openEditor(q)" :disabled="!isWriteAnswer(qi)">查看代码</a-button>
                    </div>
                  </a-col>
                </a-row>
                <a-divider />
                <a-row>
                  <a-col :span="8">
                    <p>{{$t('exam.answer')}}:
                      <a-button v-if="paperQuestion[qi].questionAnalysisFile" type="primary" size="large" @click="openEditor(q, true)">查看答案</a-button>
                      <span v-else>{{answer2Text(paperQuestion[qi])}}</span>
                    </p>

                    <a-button v-if="q.mediaId != null" @click="openVideo(q.mediaId)" type="primary">视频解析</a-button>

                  </a-col>
                  <a-col :span="10" v-if="q.questionAnalysis">
                      <p style="color:red;">{{$t('exam.analysis')}}：</p>
                      <div v-html-md="q.questionAnalysis"></div>
                    </a-col>
                  <a-col :span="24" v-if="q.myTestCase">
                    <a-divider>测试用例</a-divider>
                    <a-row :gutter="[16,16]">
                      <a-col :span="3">用例名称</a-col>
                      <a-col :span="2">得分</a-col>
                      <a-col :span="5">输入</a-col>
                      <a-col :span="7">输出</a-col>
                      <a-col :span="7">错误</a-col>
                    </a-row>
                    <a-row v-for="(c,i) in JSON.parse(q.myTestCase)" :key="i" :gutter="[16,16]">
                      <a-col :span="3">{{c.name}}</a-col>
                      <a-col :span="2">{{c.gotScore}}</a-col>
                      <a-col :span="5"><j-ellipsis :value="c.input" :length="80" /></a-col>
                      <a-col :span="7"><j-ellipsis :value="c.output" :length="80" /></a-col>
                      <a-col :span="7">
                        <a-tooltip placement="top">
                          <template slot="title">
                            <p>{{c.message}}</p>
                            <br>
                            <p>{{c.stderr}}</p>
                          </template>
                          {{c.error}}
                        </a-tooltip>
                      </a-col>
                    </a-row>
                  </a-col>
                </a-row>
              </a-card>
            </div>
          </a-card>
        </a-layout-content>
      </a-layout>
    </a-layout>
        <!--解析 -->
    <template>
      <div>
        
          <a-modal
              title="视频解析"
              :width="800"
              :visible="videoVisible"
              @cancel="videoHandleCancel"
              @ok="videoHandleCancel"
              cancelText="关闭"
              wrapClassName="ant-modal-cust-warp"
              style="top:5%;height: 85%;overflow-y: hidden">

              <a-table :dataSource="dataSource" :columns="columns" :pagination="false">
                <span slot="action" slot-scope="text, record">
                  <a @click="playVideo(record.fileUrl)">播放</a>
              </span>
              </a-table>
          </a-modal>
      </div>
    </template>
    <template>
      <a-modal :width="800" :visible="playVisible" @cancel="playHandleCancel" @ok="playHandleCancel">
            <PreviewVideo :src="palyUrl" :playbackRate="playbackRate" hoverPlay leavePause controls/>
          </a-modal>
    </template>
    <!--支付弹窗 -->
    <template>
      <div>
        
          <a-modal
              title="扫码支付"
              :width="800"
              :visible="vipVisible"
              :confirmLoading="confirmLoading"
              @cancel="handleCancel"
              cancelText="关闭"
              @ok="handleOk"
              okText="我已完成支付?"
              wrapClassName="ant-modal-cust-warp"
              style="top:5%;height: 85%;overflow-y: hidden">

            <div class="payment-info">
              <span class="vip-level">该试卷需要的会员的等级：{{ vipLevel.vipName }}</span>
              <span class="vip-price">价格：{{ vipLevel.price / 100 }}￥</span>
            </div>

            <div class="qr-code-container">
              <div class="qr-code-header">
                <img src="@/assets/wxlogo.png" class="wx-logo" />
              </div>
              <div class="qr-code-body">
                <canvas ref="qrcodeCanvas"></canvas>
                <div>请使用微信扫码二维码完成支付</div>
              </div>
            </div>
          </a-modal>
        
      </div>

    </template>
    <a-modal
      :width="'800px'"
      :visible="paperDescVisible"
      :title="$t('exam.paperDesc')"
      :destroyOnClose="true"
      :footer="null"
      @cancel="paperDescVisible=false"
    >
      <div v-html-md="paperInfo.paperDesc"></div>
    </a-modal>
    <!-- 编辑器 -->
    <a-modal :width="'100%'" :visible="editorVisible" :maskClosable="false" :dialogStyle="{top: 0}" :bodyStyle="{padding:0}"
      :destroyOnClose="true" :footer="null" @cancel="editorVisible=false">
      <a-icon slot="closeIcon" type="close-circle" theme="twoTone" style="font-size: 30px;line-height: 70px;"/>
      <div slot="title">
        <a-row>
           <a-col :span="8">
            <span>{{currentQuestionInfo.questionName}}</span>
           </a-col>
          <a-col :span="8">
            <a-button v-if="currentQuestionInfo.questionType!=8" type="primary" @click="viewStemVisible=true">{{$t('exam.viewQuestionStem')}}</a-button>
          </a-col>
        </a-row>
        </div>
      <iframe :src="editorUrl" id="player" frameborder="0" width="100%" style="height:calc(100vh - 70px);"
        scrolling="no"></iframe>
    </a-modal>
    <!-- 查看题干 -->
    <a-modal :width="800" :visible="viewStemVisible" :footer="null" @cancel="viewStemVisible=false">
      <div slot="title">
        <h3 style="display: inline;">{{$t('exam.viewQuestionStem')}}</h3>
        <a-divider type="vertical"></a-divider>
        <Voice v-if="userPaperInfo.questionVoice==1" :text="currentQuestionInfo.voiceText" size="20px"/>
      </div>
      <div v-html-md="currentQuestionInfo.questionStem">
      </div>
    </a-modal>
  </a-spin>
  </div>
</template>


<script>
import Vue from 'vue'
import  { examMixins } from '@/utils/examMixins'
import { getAction, postAction } from '@/api/manage'
import JEllipsis from "@/components/jeecg/JEllipsis";
import { Modal, Spin, Button, message } from 'ant-design-vue';
import PreviewVideo from '@/components/tools/PreviewVideo'
var QRCode = require('qrcode')
var canvas = ''
export default {
  name: 'UserPaperPreview',
  mixins: [examMixins],
  components: 
    {JEllipsis,
    'a-modal': Modal,
    'a-spin': Spin,
    'a-button': Button,
    PreviewVideo
    },
  data() {
    return {
      heightOffset: 0,
      paperId: '',
      paperInfo: {}, //试卷信息
      userInfo: {}, //学生信息
      paperDepart: {}, //排课信息
      userPaperInfo: {}, //用户答题卡信息
      questions: [],
      paperQuestion: [], //已经过转换的题目信息
      questionSections:{},//题目分类信息
      paperAnswer: [], // 答题卡信息
      userPaperId: '', // 答题卡ID
      paperDescVisible: false, //试卷介绍是否可见
      editorVisible: false,
      editorUrl: '',
      viewStemVisible: false, //查看题干modal
      videoVisible: false,
      playVisible: false,
      vipVisible: false,
      createLoading: false,
      vipLevel:{},
      payUrl: '',
      confirmLoading: false,
      palyUrl: '',
      playbackRate: 1.0, //播放速度
      dataSource: [
          
        ],

        columns: [
          {
            title: '序号',
            key: 'index',
            customRender: (text, record, index) => index + 1,
          },
          {
            title: '视频名称',
            dataIndex: 'fileName',
            key: 'fileName',
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: 'center',
            scopedSlots: { customRender: 'action' },
        },
        ],
    }
  },
  created() {
    this.userPaperId = this.$route.query.id
    this.getUserPaperInfo(this.userPaperId)
  },
  mounted() {
    let paperHeader = document.getElementById('paper-header')
    this.heightOffset = paperHeader.clientHeight + paperHeader.offsetTop
  },
  computed:{
  },
  methods: {
    reviewPaper() {
      console.log(this.paperAnswer)
      postAction('/teaching/teachingPaper/reviewUserPaper?id=' + this.userPaperId, this.paperAnswer).then((res) => {
        if (res.success) {
          this.userPaperId = res.result
        }
      })
    },
    //获取答卷
    getUserPaperInfo(id) {
      this.paperQuestion = []
      return getAction(`/teaching/teachingPaper/getUserPaper?userPaperId=${id}`).then((res) => {
        if (res.success && res.result != null) {
          this.paperInfo = res.result.paper
          this.userInfo = res.result.userInfo
          this.userPaperInfo = res.result.userPaper
          this.paperDepart = res.result.paperDepart
          let questions = res.result.question
          this.parseQuestion(questions)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    parseQuestion(questions) {
      let currentSection = null;
      for (let qi in questions) {
        let q = questions[qi]
        console.log("parse question:", q);
        //解析题目分类
        
        if(q.questionSection){
          currentSection = qi
          this.questionSections[qi] = {
            text:q.questionSection,
            count:0,
            score:0
          }
        }
        if(currentSection!=null){
          this.questionSections[currentSection].count += 1;
          this.questionSections[currentSection].score += q.paperQuestionScore;
        }

        if (q.questionOptions != null) {
          q.questionOptions = JSON.parse(q.questionOptions)
        }
        this.paperQuestion.push(q)

        this.paperAnswer.push({ 
          id: q.id,
          qid: q.questionId, 
          gotScore: q.gotScore,
          reviewComment: q.reviewComment,
          myAnswer: this.parseAnswer(q.questionType, q.myAnswer), 
          myAnswerFile: q.myAnswerFile })
        //渲染填空题dom
        if(q.questionType == 4){
          this.renderGapFillingStemDom(q, qi)
        }      
      }
    },
    openVideo(mediaId){
      getAction("/teaching/teachingCourseMedia/queryVideoById", {
        mediaId: mediaId
      }).then(res =>{
        if(res.code === 200){
          this.dataSource = res.result
          this.videoVisible = true
        }else if(res.code === 500){
          this.showPurchaseModal(mediaId)
        }
        //console.log(res)
      })
    },
    playVideo(url){
      this.palyUrl = url
      this.playVisible = true
      console.log(this.palyUrl)
    },
    showPurchaseModal(mediaId) {
      Modal.confirm({
        title: '您暂未有该视频权限，是否购买会员？',
        okText: '去购买',
        cancelText: '关闭',
        onOk: () => {
          // 设置加载状态为 true
          this.createLoading = true;
          // 处理去购买的逻辑
          this.goToPurchasePage(mediaId);
          
          
        },
        onCancel: () => {
          // 处理关闭逻辑
          console.log('关闭弹窗');
        },
      });
    },
    async goToPurchasePage(mediaId) {
      // 跳转到购买页面的逻辑
      console.log('去购买页面');
      try{
        await this.getVipLevelByMediaId(mediaId);
      } finally{
        this.createLoading = false;
      }
      
    },
    //取消支付
    handleCancel () {
      this.closeVip()
    },
    //确认支付完成
    handleOk () {
      this.closeVip()
      // 刷新页面
      window.location.reload();
    },
    closeVip () {
      this.$emit('close');
      this.vipVisible = false;
    },
    //根据课件id查询所需要的vip等级
    async getVipLevelByMediaId(mediaId) {
      try{
        const res = await getAction('/teaching/teachingVip/getVipByMediaId', { mediaId: mediaId });
        if(res.success){
          this.vipLevel = res.result
          await this.createVipOrder(this.vipLevel.id, this.vipLevel.price)
        }else {
            this.$message.error(res.message)
          }
      }catch(e) {
        console.log(e);
      }
    },

    //购买下单
    async createVipOrder(id,price) {
      try {
        const params = {
          vipId: id,
          payMode: 1,
          orderPrice: price,
        };
        const res = await postAction('/teaching/teachingOrder/createVipOrder', params);
        if (!res.success) {
          message.error(res.message);
          return;
        }
        this.payUrl = res.message;
        this.vipVisible = true;
        this.$nextTick(() => {
          this.generateQRCode();
        });
      } catch (err) {
        message.error(err.message);
      }
    },

    //生成二维码
    generateQRCode() {
      const canvas = this.$refs.qrcodeCanvas;
      QRCode.toCanvas(canvas, this.payUrl, { width: 200 }, function (error) {
        if (error) console.error(error);
        console.log('二维码生成成功');
      });
    },
    //关闭视频解析列表
    videoHandleCancel () {
      this.videoVisible = false
    },
    //关闭播放器
    playHandleCancel(){
      this.palyUrl = ''
      this.playVisible = false
    }
  },
}
</script>

<style lang="less" scoped>
/deep/p{
  margin-bottom: .5em;
}
.ant-layout {
  width: 100%;
  background: transparent;
}
.ant-layout-header {
  background: #fff;
}
.ant-layout-sider {
  background: #fff;
  text-align: center;
}
.remain-time {
  color: red;
  font-size: 20px;
}
.question-index {
  text-align: left;
  .question-section {
    margin: 10px 0px;
  }
  .ant-tag {
    height: 30px;
    width: 30px;
    font-size: 14px;
    line-height: 28px;
    margin-top: 4px;
  }
}
.paper-content {
  .question-card {
    margin-bottom: 20px;
  }
  .question-section {
    margin: 10px;
  }
  .question-stem {
    width: 100%;
    max-height: 500px;
    overflow: auto;
    span,
    > div {
      display: inline-block;
      vertical-align: top;
    }
  }
  .ant-radio-wrapper,.ant-checkbox-wrapper {
    display: block !important;
    margin-left: 0px;
    margin-bottom: .5em;
  }
  .question-options-content {
    display: inline-block;
  }
  .question-letter{
    vertical-align: top;
    margin-right: 10px;
  }
  /deep/.ant-checkbox, /deep/.ant-radio{
    vertical-align: top;
    top: 0.2em;
  }
}
.video-info {
  margin: 16px 0;
  font-size: 16px;
  font-weight: bold;
  text-align: left;
}

.vip-video {
  display: block;
  margin-bottom: 8px;
}
.payment-info {
  margin: 16px 0;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
}

.vip-level,
.vip-price {
  display: block;
  margin-bottom: 8px;
}

.qr-code-container {
  border: 1px solid #f5f5f5;
  height: 300px;
  width: 70%;
  margin: 0 auto;
  padding: 16px;
  box-sizing: border-box;
}

.qr-code-header {
  text-align: center;
  margin-bottom: 16px;
}

.wx-logo {
  width: 100px;
  height: 25px;
}

.qr-code-body {
  text-align: center;
}
</style>